import React from "react";
import InputForm from "./components/InputForm";

function App() {
  return (
      <div>
        <InputForm/>
      </div>
  );
}

export default App;
